
export type SolveCornerPlacementModelMode = typeof SolveCornerPlacementModelMode[keyof typeof SolveCornerPlacementModelMode];


export const SolveCornerPlacementModelMode = {
  Automatic: 'Automatic',
  Manual: 'Manual',
} as const;
